"use client";

import { useContext } from "react";

import { BranchContext } from "../lib/providers/BranchProvider";

export const useBranch = () => useContext(BranchContext);
